import { render, staticRenderFns } from "./FaturaCiktisiButon.vue?vue&type=template&id=1b362182"
import script from "./FaturaCiktisiButon.vue?vue&type=script&lang=js"
export * from "./FaturaCiktisiButon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports